import { render, staticRenderFns } from "./foreUPReservationGroups.vue?vue&type=template&id=0f8908e0&scoped=true"
import script from "./foreUPReservationGroups.vue?vue&type=script&lang=js"
export * from "./foreUPReservationGroups.vue?vue&type=script&lang=js"
import style0 from "./foreUPReservationGroups.vue?vue&type=style&index=0&id=0f8908e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8908e0",
  null
  
)

export default component.exports